import Api from "./base/api-base";

export default class ConstructionRefineApi {

  list(date) {
    return Api.get({
      endpoint: Api.endpoint.construction_refine,
      id: date
    });
  }
}
